<template>
    <div class="users box-white-wrapper">
        <vs-table search :data="credits" pagination max-items="10">
            <template slot="header">
                <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Agregar Cr&eacute;dito</vs-button>
            </template>
            <template slot="thead">
                <vs-th sort-key="name">Nombre</vs-th>
                <vs-th sort-key="nameLC">Linea de cr&eacute;dito</vs-th>
                <vs-th sort-key="limit"> Limite Cr&eacute;dito</vs-th>
                <vs-th sort-key="avaibleLimit">Cr&eacute;dito Disponible</vs-th>
                <vs-th sort-key="id" class=""></vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].name"> {{data[indextr].name}} </vs-td>
                    <vs-td :data="data[indextr].nameLC"> {{data[indextr].nameLC}} </vs-td>
                    <vs-td :data="data[indextr].limit"> {{data[indextr].limit}} USD</vs-td>
                    <vs-td :data="data[indextr].avaibleLimit"> {{ formatNumber(data[indextr].avaibleLimit) }} USD</vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                            <a href="javascript:void(0)" class="" @click="editCredit(data[indextr].id)"><feather type="edit-2"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].id)" v-if="data[indextr].st01Code === 1 "><feather type="trash"/></a>
                            <a href="javascript:void(0)" class="" @click="openConfirmDialog(data[indextr].id)" v-if="data[indextr].st01Code === 2 "><feather type="check-circle"/></a>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
         <transition name="fade">
            <modalBasic :show="modalActive">
                <div class="modal-header" slot="modal-header">{{ modalTitle }}</div>
                <div class="modal-body limit-body" slot="modal-body">
                    <form>
                        
                        <div :class="['form-input', {'has-error': $v.credit.customer.$error }]" >
                            <label class="vs-input--label">Cliente</label>
                            <select-input :options="customers" v-model="$v.credit.customer.$model"></select-input>
                            <span class="error-text" v-if="$v.credit.customer.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        
                        <div :class="['form-input', {'has-error': $v.credit.creditLine.$error }]" >
                            <label class="vs-input--label">Linea cr&eacute;dito</label>
                            <select-input :options="creditLines" v-model="$v.credit.creditLine.$model"></select-input>
                            <span class="error-text" v-if="$v.credit.creditLine.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        
                        <div :class="['form-input', {'has-error': $v.credit.limit.$error }]" >
                            <vs-input label="Limite" v-model.trim="$v.credit.limit.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.credit.limit.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        
                    </form>
                </div>
                <div class="modal-footer" slot="modal-footer">
                    <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                    <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                        @click="handleRequestCreditLine" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                </div>
            </modalBasic>
         </transition>
    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { required } from 'vuelidate/lib/validators'
import modalBasic from '@/components/Modal/Basic.vue'
import CreditLineModel from '@/models/CreditLineModel'
import CreditModel from '@/models/CreditModel'
import CreditDataService from "@/services/CreditDataService"
import ClientDataService from "@/services/ClientDataService"
import SelectInput from '@/components/Form/Select-Input.vue'

export default {
    name: 'CreditLine',
    mixins: [helper],
    components: {
      modalBasic,
      SelectInput
    },
    data() {
      return {
        customers: [],
        credits: [],
        credit: new CreditModel(),
        creditLines: [],
        creditLine: new CreditLineModel(),
        currentx: 5,
        isUpdating: false,
        confirmStatus: false,
        modalTitle: 'Asignar Crédito',
        modalActive: false,
      }
    },
    validations: {
        credit: {
            customer   : { required },
            creditLine : { required },
            limit  : { required },
        }
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveCustomers()
      this.retrieveCredits()
      this.retrieveCreditLines()
    },
    methods:{
        retrieveCustomers() {
            ClientDataService.getAll()
            .then(response => {
                response.data.forEach(element => {
                this.customers.push({
                        id: element.id, 
                        name: element.firstName + " " + element.lastName,
                        email: element.email,
                        customerType: element.typecode
                    })
                });
            })
            .catch(e => {
                console.log(e)
                this.$vs.notify({title:'Error!',text:'Error obteniendo los clientes!',color:'danger',icon:'error_outline'})
            });
        },
        retrieveCredits() {
            CreditDataService.get('/creditData')
            .then(response => {
                this.credits = response.data;
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los creditos asignados!',color:'danger',icon:'error_outline'})
            });
        },
        
        retrieveCreditLines() {
            CreditDataService.get('/creditLines')
            .then(response => {
                this.creditLines = response.data;
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los usuarios!',color:'danger',icon:'error_outline'})
            });
        },
        openModal () {
          this.modalActive = true
          this.isUpdating  = false
          this.credit    = new CreditModel()
          this.$v.$reset()
        },
        closeModal () {
          this.modalTitle  = 'Asignar Crédito'
          this.modalActive = false
          this.credit      = new CreditModel()
          this.$v.$reset()
        },
        editCredit (id) {
            this.modalTitle  = 'Editar Asignación de crédito'
            this.modalActive = true
            this.credit  = this.searchCredit(id)
            this.isUpdating  = true
        },
        openConfirmDialog(_id){
            this.credit    = this.searchCredit (_id)
            let modeText = this.credit.status.code == 1 ? 'desactivar el' : 'activar el'
            this.$vs.dialog({
                type:'confirm',
                title: `¡Atención!`,
                color:'',
                cancelText: 'No',
                acceptText: 'Si',
                iconPack:'home',
                text: '¿Estas seguro de '+modeText+' crédito seleccionado?',
                accept:this.changeCreditStatus
            })
        },
        changeCreditStatus(){
            this.credit.status.code = this.credit.status.code == 1 ? 2 : 1
            CreditDataService.update('/creditData', this.credit)
            .then( () => {
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.$vs.notify({title:'Información',text:'El crédito fue actualizado exitosamente!',color:'success',icon:'check'})
                this.retrieveCredits()
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error actualizando el crédito al usuario',color:'danger',icon:'error_outline'})                
            });
        },
        handleRequestCreditLine(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.saveCredit()
            } else {
                this.updateCredit()
            }
        },
        saveCredit(){
            this.loadingProgress ('#btnConfirm')
            this.confirmStatus = true
            CreditDataService.new('/creditData', this.credit)
            .then(response => {
                console.log(response)
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.modalActive = false
                this.$vs.notify({title:'Información',text:'La asignación de crédito fue creada exitosamente!',color:'success',icon:'check'})
                this.credit    = new CreditModel()
                this.$v.$reset()
                // this.retrieveCredits()
                this.credits.push(response.data.result)
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error creando la asignación de crédito.',color:'danger',icon:'error_outline'})                
            });
        
        },
        updateCredit(){
            this.loadingProgress ('#btnConfirm')
            this.confirmStatus = true
            CreditDataService.update('/creditData', this.credit)
            .then(response => {
                console.log(response)
                this.confirmStatus = false
                this.$vs.loading.close('#btnConfirm .con-vs-loading')
                this.modalActive = false
                this.$vs.notify({title:'Información',text:'La asignació de crédito fue actualizada exitosamente!',color:'success',icon:'check'})
                this.creditLine  = new CreditLineModel()
                this.$v.$reset()
                this.retrieveCredits()
            })
            .catch(e => {
                console.log(e)
                this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                this.confirmStatus = false
                this.$vs.notify({title:'Información',text:'Error actualizando la asignación de crédito.',color:'danger',icon:'error_outline'})                
            });
        
        },
        
        searchCredit (_code) {
            console.log(_code);
            let obj = this.credits.filter((item) => {
              return _code === item.id
            })
            
            obj = obj[0]
            console.log(obj)
            let credit = new CreditModel(
                obj.id,
                {
                    id: obj.cu01Id,
                    name: obj.name
                },
                {
                    code: obj.cr01Code,
                    name: obj.nameLC
                },
                obj.limit,
                { code: obj.st01Code }
            )
            return credit
        },
    }
}
</script>
